import { Box } from '@mui/material';
import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import SearchProvider from 'components/search/search.context';
import ItemsDataGrid from '../items-data-grid/items-data-grid.component';
import { useItemsFilter } from '../items-landing.hooks';
import BulkEditDataGridProvider from 'components/inc-data-grid/bulk-edit-data-grid/bulk-edit-data-grid.context';

const ItemsImported = () => {
  const search = useItemsFilter(true);

  return (
    <Box mt={2}>
      <SearchProvider value={search}>
        <SearchToolbar />
        <BulkEditDataGridProvider>
          <ItemsDataGrid isImported />
        </BulkEditDataGridProvider>
      </SearchProvider>
    </Box>
  );
};

export default ItemsImported;
